// extracted by mini-css-extract-plugin
module.exports = {"content":"shared-components-WorkModal-WorkModal__content--1Xr7F"};